/**
 * Feature flags for Goals UI and other experimental features.
 * GOALS_UI_COMPACT: Use compact inline preset row instead of large CTA card (default ON in dev).
 * GOALS_PROTOTYPE: Show prototype-only controls like Reset setup (default OFF).
 */
export const GOALS_UI_COMPACT =
  typeof process === 'undefined' || process.env?.REACT_APP_GOALS_UI_COMPACT !== 'false'

export const GOALS_PROTOTYPE =
  typeof process !== 'undefined' && process.env?.REACT_APP_GOALS_PROTOTYPE === 'true'
